import { environments, currentEnvironment, switchEnvironment } from '../lib/portal';

/** Sandbox / Production segmented switch. Each environment is a separate deployment with its own sign-in. */
export function EnvironmentSwitch() {
  const envs = environments();
  const cur = currentEnvironment();
  if (envs.length < 2) return null;
  return (
    <div role="group" aria-label="Environment" className="p-btn-group dv-env-switch">
      {envs.map((e) => (
        <button
          key={e.id}
          type="button"
          className="p-btn small"
          aria-pressed={e.id === cur?.id}
          disabled={!e.available}
          title={e.available ? `Switch to ${e.label}` : e.note ?? `${e.label} is not available yet`}
          onClick={() => switchEnvironment(e.id)}
        >
          {e.label}
          {!e.available && <span className="dv-soon">· soon</span>}
        </button>
      ))}
    </div>
  );
}
